import { QuoteListApp } from "document/list/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const quoteRoute: RouteObject = {
  path: "quote",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: QuoteListApp,
  }]
};